import { Table } from 'react-daisyui';
import moment from 'moment';
import { SortArrow } from '@/components/SortArrow/SortArrow';
import type { EventLog } from '@types';
import { Sort } from '@/types';

function EventsTable({
  records,
  sortBy,
  sort,
}: {
  records: EventLog[];
  sortBy: (field: string) => void;
  sort: Sort;
}) {
  return (
    <Table zebra id='table-logs' className='w-full m-2'>
      <Table.Head className='text-sm'>
        <div
          onClick={() => sortBy('action')}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              sortBy('action');
            }
          }}
          role='button' // This indicates the div is being used as a button
          tabIndex={0}
          className='cursor-pointer'
          data-testid='log-name-sorting'
        >
          <span className='text-base font-bold capitalize'>
            Title
            <SortArrow sort={sort} fieldName='action' />
          </span>
        </div>
        <div
          onClick={() => sortBy('extra_data->>"email_address"')}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              sortBy('extra_data->>"email_address"');
            }
          }}
          role='button' // This indicates the div is being used as a button
          tabIndex={0}
          className='cursor-pointer'
        >
          <span className='text-base font-bold capitalize'>
            User
            <SortArrow sort={sort} fieldName='extra_data->>"email_address"' />
          </span>
        </div>
        <div
          onClick={() => sortBy('human_readable')}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              sortBy('human_readable');
            }
          }}
          role='button' // This indicates the div is being used as a button
          tabIndex={0}
          className='cursor-pointer'
        >
          <span className='text-base font-bold capitalize'>
            Date
            <SortArrow sort={sort} fieldName='human_readable' />
          </span>
        </div>
        <div
          onClick={() => sortBy('extra_data->>"uploaded_file"')}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              sortBy('extra_data->>"uploaded_file"');
            }
          }}
          role='button' // This indicates the div is being used as a button
          tabIndex={0}
          className='cursor-pointer'
        >
          <span className='text-base font-bold capitalize'>
            Note
            <SortArrow sort={sort} fieldName='extra_data->>"uploaded_file"' />
          </span>
        </div>
        <div
          onClick={() => sortBy('extra_data->>"path"')}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              sortBy('extra_data->>"path"');
            }
          }}
          role='button' // This indicates the div is being used as a button
          tabIndex={0}
          className='cursor-pointer'
        >
          <span className='text-base font-bold capitalize'>
            Link
            <SortArrow sort={sort} fieldName='extra_data->>"path"' />
          </span>
        </div>
      </Table.Head>
      {records?.length > 0 && (
        <Table.Body className='text-xs'>
          {records.map((log) => (
            <Table.Row
              key={log.id}
              hover
              data-testid='log-list-item'
              className='cursor-pointer w-full'
            >
              <div className='whitespace-pre-line break-words'>
                {log.action as string}
              </div>
              <div>{log.extra_data?.email_address as string}</div>
              <div>
                {moment(
                  new Date(log.human_readable as unknown as string)
                ).format('MMM DD, YYYY')}
              </div>
              <div className='whitespace-pre-line break-words'>
                {log.extra_data?.uploaded_file}
                {log.extra_data?.downloaded_file}
                {log.extra_data?.category &&
                  `Category: ${log.extra_data.category}, `}
                {log.extra_data?.memo && `Memo: ${log.extra_data.memo} `}
                {!log.extra_data?.category &&
                  !log.extra_data?.memo &&
                  !log.extra_data?.uploaded_file &&
                  !log.extra_data?.downloaded_file &&
                  'none'}
              </div>
              <div className='overflow-ellipsis'>
                {log.extra_data?.path || 'none'}
              </div>
            </Table.Row>
          ))}
        </Table.Body>
      )}
    </Table>
  );
}

export default EventsTable;
